import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// import { ColorPickerModule } from 'ngx-color-picker';

import { PalettePickerComponent } from './palette-picker/palette-picker.component';
// import { FontPickerComponent } from './font-picker/font-picker.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLineModule, MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';

import { SubPalettePickerComponent } from './palette-picker/sub-palette-picker/sub-palette-picker.component';
import { ColorPickerComponent } from './palette-picker/color-picker/color-picker.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {ColorPickerModule} from 'ngx-color-picker';
import {ThemeBuilderComponent} from './theme-builder/theme-builder.component';
import {SimpleFileUploaderModule} from '../app/modules/simple-file-uploader/simple-file-uploader.module';
import {PublicFilesService} from '../app/services/public-files.service';
import {QuillModule} from 'ngx-quill';
import {TextColorPipe} from './pipes/text-color.pipe';
import {LddModuleColorPickerComponent} from './ldd-module-color-picker/ldd-module-color-picker.component';
import {SharedModule} from '../app/shared/shared.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
// import {ColorPickerModule} from '@iplab/ngx-color-picker';

@NgModule({
  declarations: [
    PalettePickerComponent,
    // FontPickerComponent,
    ThemeBuilderComponent,
    // LightnessPickerComponent,
    SubPalettePickerComponent,
    ColorPickerComponent,
    TextColorPipe,
    LddModuleColorPickerComponent,
  ],
  imports: [
    // HttpClientModule,
    // BrowserModule,
    // ColorPickerModule,
    FormsModule,
    ScrollingModule,
    ReactiveFormsModule,
    // BrowserAnimationsModule,
    CommonModule,
    MatMenuModule,
    MatCardModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatIconModule,
    MatLineModule,
    MatListModule,
    MatTabsModule,
    MatTableModule,
    MatChipsModule,
    MatInputModule,
    MatRadioModule,
    MatDialogModule,
    MatSelectModule,
    MatTooltipModule,
    MatLineModule,
    MatSidenavModule,
    MatStepperModule,
    MatToolbarModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatOptionModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    MatExpansionModule,

    ColorPickerModule,

    SimpleFileUploaderModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{'header': 1}, {'header': 2}],               // custom button values
          [{'list': 'ordered'}, {'list': 'bullet'}],
          // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
          [{'direction': 'rtl'}],                         // text direction

          [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
          [{'header': [1, 2, 3, 4, 5, 6, false]}],

          [{'color': []}, {'background': []}],          // dropdown with defaults from theme
          [{'font': []}],
          [{'align': []}],
          //
          ['clean'],                                         // remove formatting button

          // ['link', 'image', 'video']                         // link and image, video
        ]
      }
    }),
    SharedModule,
  ],
  exports: [
    PalettePickerComponent,
    // FontPickerComponent,
    ThemeBuilderComponent,
    SubPalettePickerComponent,
    ColorPickerComponent,
  ],
  providers: [
    PublicFilesService,
  ],
  bootstrap: []
})
export class ThemeBuilderModule { }
